// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackagesPage_BidPackageBidderFragmentDoc, BidPackagesPage_BidPackageVersionFragmentDoc } from './BidPackagesPage.generated';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidCoveragePageQueryVariables = Types.Exact<{
  filter: Types.CostCodeBidCoverageFilter;
}>;


export type BidCoveragePageQuery = { __typename?: 'Query', costCodeBidCoverage: Array<{ __typename?: 'CostCodeBidCoverageResult', costCode?: { __typename?: 'CostCode', id: string, name: string, displayName: string } | null | undefined, alerts: Array<{ __typename?: 'CostCodeBidCoverageAlert', title: string, type: Types.CostCodeBidCoverageAlertType, tooltip: string }>, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, isPlanBasedV2: boolean, isUnitBased: boolean, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
            | { __typename?: 'ReadyPlan', id: string, name: string }
            | { __typename?: 'PlanPackage', id: string, name: string }
            | { __typename?: 'DesignPackage', id: string, name: string }
            | { __typename?: 'ProductOffering', id: string, name: string }
           }> }, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
        | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined }> }> }> };

export type BidCoveragePage_CostCodeBidCoverageFragment = { __typename?: 'CostCodeBidCoverageResult', costCode?: { __typename?: 'CostCode', id: string, name: string, displayName: string } | null | undefined, alerts: Array<{ __typename?: 'CostCodeBidCoverageAlert', title: string, type: Types.CostCodeBidCoverageAlertType, tooltip: string }>, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, isPlanBasedV2: boolean, isUnitBased: boolean, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         }> }, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
      | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined }> }> };

export type BidCoveragePage_BidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, isPlanBasedV2: boolean, isUnitBased: boolean, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       }> }, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
    | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined }> };

export const BidCoveragePage_BidPackageFragmentDoc = gql`
    fragment BidCoveragePage_BidPackage on BidPackage {
  id
  name
  isPlanBasedV2
  isUnitBased
  status {
    code
    name
  }
  bidPackageGroup {
    id
  }
  costType {
    code
    name
  }
  latestVersion {
    ...BidPackagesPage_BidPackageVersion
  }
  projects {
    ...Named
    ... on Community {
      id
      productOfferings {
        id
        status {
          code
        }
      }
    }
    ... on Market {
      id
      children {
        id
        productOfferings {
          id
          status {
            code
          }
        }
      }
    }
  }
  activeBidders {
    ...BidPackagesPage_BidPackageBidder
  }
}
    ${BidPackagesPage_BidPackageVersionFragmentDoc}
${NamedFragmentDoc}
${BidPackagesPage_BidPackageBidderFragmentDoc}`;
export const BidCoveragePage_CostCodeBidCoverageFragmentDoc = gql`
    fragment BidCoveragePage_CostCodeBidCoverage on CostCodeBidCoverageResult {
  costCode {
    id
    name
    displayName
  }
  alerts {
    title
    type
    tooltip
  }
  bidPackages {
    ...BidCoveragePage_BidPackage
  }
}
    ${BidCoveragePage_BidPackageFragmentDoc}`;
export const BidCoveragePageDocument = gql`
    query BidCoveragePage($filter: CostCodeBidCoverageFilter!) {
  costCodeBidCoverage(filter: $filter) {
    ...BidCoveragePage_CostCodeBidCoverage
  }
}
    ${BidCoveragePage_CostCodeBidCoverageFragmentDoc}`;

/**
 * __useBidCoveragePageQuery__
 *
 * To run a query within a React component, call `useBidCoveragePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidCoveragePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidCoveragePageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBidCoveragePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidCoveragePageQuery, BidCoveragePageQueryVariables> & ({ variables: BidCoveragePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidCoveragePageQuery, BidCoveragePageQueryVariables>(BidCoveragePageDocument, options);
      }
export function useBidCoveragePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidCoveragePageQuery, BidCoveragePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidCoveragePageQuery, BidCoveragePageQueryVariables>(BidCoveragePageDocument, options);
        }
// @ts-ignore
export function useBidCoveragePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidCoveragePageQuery, BidCoveragePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidCoveragePageQuery, BidCoveragePageQueryVariables>;
export function useBidCoveragePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidCoveragePageQuery, BidCoveragePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidCoveragePageQuery | undefined, BidCoveragePageQueryVariables>;
export function useBidCoveragePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidCoveragePageQuery, BidCoveragePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidCoveragePageQuery, BidCoveragePageQueryVariables>(BidCoveragePageDocument, options);
        }
export type BidCoveragePageQueryHookResult = ReturnType<typeof useBidCoveragePageQuery>;
export type BidCoveragePageLazyQueryHookResult = ReturnType<typeof useBidCoveragePageLazyQuery>;
export type BidCoveragePageSuspenseQueryHookResult = ReturnType<typeof useBidCoveragePageSuspenseQuery>;
export type BidCoveragePageQueryResult = ApolloReactCommon.QueryResult<BidCoveragePageQuery, BidCoveragePageQueryVariables>;